// Pekala Mock Data

export const products = [
  // Süt Ürünleri - Ayran
  {
    id: 1,
    name: "Pekala Ayran",
    category: "süt",
    size: "150 ml",
    image: "https://customer-assets.emergentagent.com/job_94e13a18-98ce-4a37-8fca-c5700d52d67c/artifacts/bt48izpo_Ayran.png",
    slogan: "lezzetin âlâsı",
    description: "Geleneksel Türk lezzeti ayran, en taze sütlerden hazırlanır. Yarım yağlı, doğal ve okul gıdası onaylı.",
    features: [
      "Yarım Yağlı Ayran (En az %0,8 süt yağı, En az %2 protein)",
      "Okul Gıdası Sertifikalı",
      "TR 63-0202"
    ],
    nutrition: {
      energy: "109.5 kJ / 26 kcal",
      protein: "2 g",
      carbs: "2.65 g",
      fat: "0.8 g",
      calcium: "92 mg"
    },
    ingredients: "Homojenize inek sütü, starter kültür, tuz (max 0,9)"
  },
  {
    id: 2,
    name: "Pekala Ayran",
    category: "süt",
    size: "170 ml",
    image: "https://customer-assets.emergentagent.com/job_94e13a18-98ce-4a37-8fca-c5700d52d67c/artifacts/bt48izpo_Ayran.png",
    slogan: "lezzetin âlâsı",
    description: "Orta boy ayran, günlük tüketim için ideal miktar. Taze ve doğal.",
    features: [
      "Yarım Yağlı Ayran (En az %0,8 süt yağı, En az %2 protein)",
      "Okul Gıdası Sertifikalı",
      "TR 63-0202"
    ],
    nutrition: {
      energy: "109.5 kJ / 26 kcal",
      protein: "2 g",
      carbs: "2.65 g",
      fat: "0.8 g",
      calcium: "92 mg"
    },
    ingredients: "Homojenize inek sütü, starter kültür, tuz (max 0,9)"
  },
  {
    id: 3,
    name: "Pekala Ayran",
    category: "süt",
    size: "190 ml",
    image: "https://customer-assets.emergentagent.com/job_94e13a18-98ce-4a37-8fca-c5700d52d67c/artifacts/bt48izpo_Ayran.png",
    slogan: "lezzetin âlâsı",
    description: "Büyük boy ayran, tok tutması için daha fazla miktar. Doğal ve sağlıklı.",
    features: [
      "Yarım Yağlı Ayran (En az %0,8 süt yağı, En az %2 protein)",
      "Okul Gıdası Sertifikalı",
      "TR 63-0202"
    ],
    nutrition: {
      energy: "109.5 kJ / 26 kcal",
      protein: "2 g",
      carbs: "2.65 g",
      fat: "0.8 g",
      calcium: "92 mg"
    },
    ingredients: "Homojenize inek sütü, starter kültür, tuz (max 0,9)"
  },
  
  // Süt Ürünleri - Yoğurt
  {
    id: 5,
    name: "Pekala Yoğurt",
    category: "süt",
    size: "2000g",
    image: "https://customer-assets.emergentagent.com/job_pekala-natural/artifacts/apsrpwwu_Pekala_Yoghurt.png",
    slogan: "lezzetin âlâsı",
    description: "Aile boyu yoğurt, kremsi dokusu ve doğal tadıyla sofraların vazgeçilmezi.",
    features: [
      "Homojenize Yarım Yağlı Yoğurt (min %1.5)",
      "Katkısız, Doğal (%2-3 süt tozu içerebilir)",
      "TR 63-0202"
    ],
    nutrition: {
      energy: "54 kcal",
      protein: "3 g",
      carbs: "6.2 g",
      fat: "1.5 g",
      calcium: "134 mg (17%)"
    },
    ingredients: "Homojenize yarım yağlı inek sütü, yoğurt kültürü. %2-3 süt tozu içerebilir."
  },
  {
    id: 6,
    name: "Pekala Yoğurt",
    category: "süt",
    size: "4000g",
    image: "https://customer-assets.emergentagent.com/job_pekala-natural/artifacts/apsrpwwu_Pekala_Yoghurt.png",
    slogan: "lezzetin âlâsı",
    description: "Ekonomik aile boyu yoğurt, büyük aileler için ideal miktar.",
    features: [
      "Homojenize Yarım Yağlı Yoğurt (min %1.5)",
      "Katkısız, Doğal (%2-3 süt tozu içerebilir)",
      "TR 63-0202"
    ],
    nutrition: {
      energy: "54 kcal",
      protein: "3 g",
      carbs: "6.2 g",
      fat: "1.5 g",
      calcium: "134 mg (17%)"
    },
    ingredients: "Homojenize yarım yağlı inek sütü, yoğurt kültürü. %2-3 süt tozu içerebilir."
  },
  {
    id: 7,
    name: "Pekala Yoğurt Kova",
    category: "süt",
    size: "10 kg",
    image: "https://customer-assets.emergentagent.com/job_pekala-natural/artifacts/apsrpwwu_Pekala_Yoghurt.png",
    slogan: "lezzetin âlâsı",
    description: "Toptan satış için kova ambalaj yoğurt, işletmeler ve büyük aileler için.",
    features: [
      "Homojenize Yarım Yağlı Yoğurt (min %1.5)",
      "Katkısız, Doğal (%2-3 süt tozu içerebilir)",
      "TR 63-0202"
    ],
    nutrition: {
      energy: "54 kcal",
      protein: "3 g",
      carbs: "6.2 g",
      fat: "1.5 g",
      calcium: "134 mg (17%)"
    },
    ingredients: "Homojenize yarım yağlı inek sütü, yoğurt kültürü. %2-3 süt tozu içerebilir."
  },

  // Taze İçecekler - Limonata
  {
    id: 8,
    name: "Pekala Limonata",
    category: "içecek",
    size: "1 Litre",
    image: "https://customer-assets.emergentagent.com/job_pekala-natural/artifacts/9mrupb7s_Limonata_1Lt-Ornek.jpg",
    slogan: "lezzetin âlâsı",
    description: "Limon aromalı içecek, ev yapımı lezzette. Aile boyu şişe ambalaj.",
    features: [
      "Limon Aromalı İçecek",
      "Fenilalanin içerir, Sakkarin içerir",
      "TR-63-K-015600"
    ],
    nutrition: {
      energy: "34 kcal",
      protein: "0 g",
      carbs: "9 g",
      fat: "0 g",
      fiber: "0 g",
      cholesterol: "0 mg",
      sodium: "0 g",
      calcium: "0 mg"
    },
    ingredients: "Su, şeker (sakkaroz), fruktoz, sitrik asit, emülsiyon (sodyum sitrat, doğala özdeş limon aroması, gam arabik, guar gam), koruyucu (potasyum sorbat, sodyum benzoat), renklendirici (E102, E104, Beta karoten)"
  },
  {
    id: 9,
    name: "Pekala Limonata Bardak",
    category: "içecek",
    size: "200 ml",
    image: "https://customer-assets.emergentagent.com/job_94e13a18-98ce-4a37-8fca-c5700d52d67c/artifacts/pud3mmzf_Limonata.png",
    slogan: "lezzetin âlâsı",
    description: "Pratik bardak ambalajda limon aromalı içecek, yanınızda taşıyabileceğiniz tazelik.",
    features: [
      "Limon Aromalı İçecek",
      "Fenilalanin içerir, Sakkarin içerir",
      "TR-63-K-015600"
    ],
    nutrition: {
      energy: "34 kcal",
      protein: "0 g",
      carbs: "9 g",
      fat: "0 g",
      fiber: "0 g",
      cholesterol: "0 mg",
      sodium: "0 g",
      calcium: "0 mg"
    },
    ingredients: "Su, şeker (sakkaroz), fruktoz, sitrik asit, emülsiyon (sodyum sitrat, doğala özdeş limon aroması, gam arabik, guar gam), koruyucu (potasyum sorbat, sodyum benzoat), renklendirici (E102, E104, Beta karoten)"
  },

  // Taze İçecekler - Vişne
  {
    id: 10,
    name: "Pekala Vişne Bardak",
    category: "içecek",
    size: "200 ml",
    image: "https://customer-assets.emergentagent.com/job_94e13a18-98ce-4a37-8fca-c5700d52d67c/artifacts/pcpctd2n_Visne.png",
    slogan: "lezzetin âlâsı",
    description: "Vişne aromalı içecek, pratik bardak ambalajda.",
    features: [
      "Vişne Aromalı İçecek",
      "Fenilalanin içerir, Sakkarin içerir",
      "TR-63-K-015600"
    ],
    nutrition: {
      energy: "34 kcal",
      protein: "0 g",
      carbs: "9 g",
      fat: "0 g",
      fiber: "0 g",
      cholesterol: "0 mg",
      sodium: "0 g",
      calcium: "0 mg"
    },
    ingredients: "Su, şeker (sakkaroz), fruktoz, sitrik asit, emülgatörler (sodyum sitrat, doğal vişne aroması, guar gam, gam arabik), koruyucular (potasyum sorbat, sodyum benzoat), renklendiriciler (E102, E104, Beta karoten)"
  },

  // Taze İçecekler - Şalgam
  {
    id: 11,
    name: "Pekala Şalgam Suyu",
    category: "içecek",
    size: "Şişe",
    image: "https://customer-assets.emergentagent.com/job_94e13a18-98ce-4a37-8fca-c5700d52d67c/artifacts/indw93xh_%C5%9Ealgam.png",
    slogan: "lezzetin âlâsı",
    description: "Geleneksel Türk içeceği şalgam suyu, acılı ve ferahlatıcı lezzet. Şişe ambalajda.",
    features: [
      "Hot Turnip Juice",
      "Geleneksel Lezzet",
      "Acı Şalgam"
    ],
    nutrition: {
      energy: "20 kcal",
      protein: "1 g",
      carbs: "4 g",
      fat: "0 g",
      sodium: "450 mg"
    },
    ingredients: "Su, şalgam, havuç, tuz, acı biber, limon tuzu"
  }
];

export const recipes = [
  {
    id: 1,
    title: "Pekala Ayran ile Karnıyarık",
    category: "Ana Yemek",
    image: "https://customer-assets.emergentagent.com/job_pekalasut-portal/artifacts/efbt9o1m_Pekala%20Ayran%20ile%20Karn%C4%B1yar%C4%B1k.png",
    description: "Geleneksel Türk mutfağının vazgeçilmez lezzeti karnıyarık, yanında soğuk Pekala ayranla mükemmel bir öğün.",
    prepTime: "30 dakika",
    cookTime: "45 dakika",
    servings: "4 kişilik",
    difficulty: "Orta",
    pekaraProduct: "Pekala Ayran",
    ingredients: [
      "4 adet orta boy patlıcan",
      "300g kıyma",
      "2 adet soğan",
      "3 adet domates",
      "2 adet sivri biber",
      "3 diş sarımsak",
      "2 yemek kaşığı salça",
      "Zeytinyağı",
      "Tuz, karabiber",
      "Pekala Ayran (servis için)"
    ],
    instructions: [
      "Patlıcanları boyuna soyun ve tuzlu suda bekletin.",
      "Kıymayı soğan, sarımsak ile kavurun.",
      "Domates ve biberleri ekleyip salçalayın.",
      "Patlıcanları kızartıp içini açın.",
      "Harç ile doldurun ve fırında pişirin.",
      "Sıcak servis edin, yanında soğuk Pekala ayran ile keyfinizi çıkarın."
    ],
    tips: "Patlıcanları tuzlu suda bekletmek acı suyunu çıkarır. Karnıyarığın yanında soğuk Pekala ayran mükemmel bir eşleşmedir."
  },
  {
    id: 2,
    title: "Pekala Şalgam ile Çiğ Köfte",
    category: "Atıştırmalık",
    image: "https://customer-assets.emergentagent.com/job_pekalasut-portal/artifacts/7qihm6ac_Pekala%20%C5%9Ealgam%20ile%20%C3%87i%C4%9F%20K%C3%B6fte.png",
    description: "Sokak lezzetlerinin klasiği çiğ köfte, acılı Pekala şalgam suyuyla vazgeçilmez bir ikili.",
    prepTime: "45 dakika",
    cookTime: "0 dakika",
    servings: "6 kişilik",
    difficulty: "Orta",
    pekaraProduct: "Pekala Şalgam Suyu",
    ingredients: [
      "500g ince bulgur",
      "2 yemek kaşığı salça",
      "2 yemek kaşığı biber salçası",
      "1 çay bardağı zeytinyağı",
      "Tuz, kimyon, pul biber",
      "Marul yaprakları",
      "Limon",
      "Pekala Şalgam Suyu"
    ],
    instructions: [
      "Bulguru ince çekili alın ve ıslatın.",
      "Salça, baharatlar ve zeytinyağını ekleyin.",
      "Uzun süre yoğurun.",
      "Ceviz büyüklüğünde yuvarlak yapın.",
      "Marul yaprağına sarın.",
      "Limon sıkın ve Pekala şalgamla servis edin."
    ],
    tips: "Çiğ köfteyi yoğururken arada ellerinizi ıslatın. Acılı Pekala şalgam suyu, çiğ köftenin en iyi tamamlayıcısıdır."
  },
  {
    id: 3,
    title: "Pekala Limonata ile Balık Izgara",
    category: "Ana Yemek",
    image: "https://customer-assets.emergentagent.com/job_pekalasut-portal/artifacts/svexjo4h_Pekala%20Limonata%20ile%20Bal%C4%B1k%20Izgara.png",
    description: "Akdeniz esintili ızgara balık, taze limon aromalı Pekala limonata ile ferahlatıcı bir öğün.",
    prepTime: "15 dakika",
    cookTime: "20 dakika",
    servings: "2 kişilik",
    difficulty: "Kolay",
    pekaraProduct: "Pekala Limonata",
    ingredients: [
      "2 adet taze çipura veya levrek",
      "Zeytinyağı",
      "Tuz, karabiber",
      "Taze limon",
      "Kekik",
      "Izgara sebzeler (biber, domates)",
      "Pekala Limonata"
    ],
    instructions: [
      "Balıkları temizleyin ve kurulayın.",
      "Zeytinyağı, tuz, kekik ile marine edin.",
      "Izgarada veya tavada pişirin.",
      "Sebzeleri de ızgara yapın.",
      "Limon sıkarak servis edin.",
      "Yanında buzlu Pekala limonata ile keyif alın."
    ],
    tips: "Balığı fazla çevirmeyin, her tarafı 5-7 dakika pişirin. Pekala limonata balığın yağlı yapısını dengeler ve ferahlık verir."
  },
  {
    id: 4,
    title: "Pekala Yoğurt ile Mantı",
    category: "Ana Yemek",
    image: "https://customer-assets.emergentagent.com/job_pekalasut-portal/artifacts/phug18oo_Pekala%20Yo%C4%9Furt%20ile%20Manti.png",
    description: "Anadolu mutfağının incisi mantı, bol Pekala yoğurtlu sosuyla vazgeçilmez lezzet.",
    prepTime: "60 dakika",
    cookTime: "30 dakika",
    servings: "4 kişilik",
    difficulty: "Zor",
    pekaraProduct: "Pekala Yoğurt",
    ingredients: [
      "500g un",
      "1 yumurta",
      "250g kıyma",
      "1 soğan",
      "500g Pekala Yoğurt",
      "3 diş sarımsak",
      "50g tereyağı",
      "Pul biber, kuru nane",
      "Tuz"
    ],
    instructions: [
      "Hamuru yoğurup ince açın.",
      "Küçük kareler kesin ve kıyma koyun.",
      "Mantıları kapatın.",
      "Kaynar tuzlu suda haşlayın.",
      "Pekala yoğurdu sarımsakla karıştırın.",
      "Mantıyı yoğurt ve tereyağ ile servis edin."
    ],
    tips: "Hamuru ne kadar ince açarsanız mantı o kadar lezzetli olur. Pekala yoğurt, mantının vazgeçilmez tamamlayıcısıdır."
  },
  {
    id: 5,
    title: "Pekala Ayran ile Lahmacun",
    category: "Ana Yemek",
    image: "https://customer-assets.emergentagent.com/job_pekalasut-portal/artifacts/wkuaxspr_Pekala%20Ayran%20ile%20Lahmacun.png",
    description: "Türk mutfağının efsane ikili lahmacun-ayran, taze Pekala ayranla tam bir ziyafet.",
    prepTime: "30 dakika",
    cookTime: "20 dakika",
    servings: "6 kişilik",
    difficulty: "Orta",
    pekaraProduct: "Pekala Ayran",
    ingredients: [
      "500g un",
      "1 paket maya",
      "300g kıyma",
      "2 soğan",
      "3 domates",
      "2 sivri biber",
      "Salça, baharatlar",
      "Maydanoz",
      "Limon",
      "Pekala Ayran"
    ],
    instructions: [
      "Hamuru hazırlayıp mayalayın.",
      "Kıymayı sebzelerle çekin.",
      "Hamuru ince açın.",
      "Harcı yayıp fırında pişirin.",
      "Maydanoz ve limon ile sarın.",
      "Soğuk Pekala ayran ile servis edin."
    ],
    tips: "Hamuru ince açmak lahmacunun sırrıdır. Sıcak lahmacun, soğuk Pekala ayran ile mükemmel uyum sağlar."
  },
  {
    id: 6,
    title: "Pekala Vişne ile Waffle",
    category: "Tatlı",
    image: "https://customer-assets.emergentagent.com/job_pekalasut-portal/artifacts/61rzi9up_Pekala%20Vi%C5%9Fne%20ile%20Waffle.png",
    description: "Kahvaltı veya tatlı keyfi için waffle, üzerine taze vişneler ve Pekala vişne içeceği.",
    prepTime: "10 dakika",
    cookTime: "15 dakika",
    servings: "4 kişilik",
    difficulty: "Kolay",
    pekaraProduct: "Pekala Vişne",
    ingredients: [
      "2 su bardağı un",
      "2 yumurta",
      "1.5 su bardağı süt",
      "50g tereyağı",
      "2 yemek kaşığı şeker",
      "1 paket kabartma tozu",
      "Taze vişneler",
      "Krema",
      "Pekala Vişne İçeceği"
    ],
    instructions: [
      "Kuru malzemeleri karıştırın.",
      "Yumurta, süt ve tereyağı ekleyin.",
      "Waffle makinesinde pişirin.",
      "Taze vişneler ve krema ile süsleyin.",
      "Yanında soğuk Pekala vişne içeceği ile servis edin."
    ],
    tips: "Waffle hamurunu dinlendirmek daha kabaran waffle sağlar. Pekala vişne içeceği, tatlının mükemmel tamamlayıcısıdır."
  },
  {
    id: 7,
    title: "Pekala Süt ile Menemen",
    category: "Kahvaltı",
    image: "https://customer-assets.emergentagent.com/job_pekalasut-portal/artifacts/vrkw771e_Pekala%20S%C3%BCt%20ile%20Menemen.png",
    description: "Klasik Türk kahvaltısının vazgeçilmezi menemen, yanında taze Pekala süt ile sağlıklı başlangıç.",
    prepTime: "10 dakika",
    cookTime: "15 dakika",
    servings: "2 kişilik",
    difficulty: "Kolay",
    pekaraProduct: "Pekala Süt",
    ingredients: [
      "4 yumurta",
      "3 domates",
      "2 sivri biber",
      "1 soğan",
      "Zeytinyağı",
      "Tuz, karabiber",
      "Pul biber",
      "Pekala Süt"
    ],
    instructions: [
      "Soğanı yemeklik doğrayıp kavurun.",
      "Biberleri ekleyin.",
      "Domatesleri ilave edip pişirin.",
      "Yumurtaları çırpıp ekleyin.",
      "Karıştırarak pişirin.",
      "Sıcak ekmek ve Pekala süt ile servis edin."
    ],
    tips: "Menemen yaparken yumurtayı fazla karıştırmayın. Kahvaltıda Pekala süt, güne sağlıklı başlamanızı sağlar."
  },
  {
    id: 8,
    title: "Pekala Ayran ile Pide",
    category: "Ana Yemek",
    image: "https://customer-assets.emergentagent.com/job_pekalasut-portal/artifacts/jbeck9pv_Pekala%20Ayran%20ile%20Pide.png",
    description: "Kıymalı pide, yanında soğuk Pekala ayranla Türk mutfağının klasik lezzeti.",
    prepTime: "30 dakika",
    cookTime: "25 dakika",
    servings: "4 kişilik",
    difficulty: "Orta",
    pekaraProduct: "Pekala Ayran",
    ingredients: [
      "500g un",
      "1 paket maya",
      "300g kıyma",
      "2 soğan",
      "2 domates",
      "2 biber",
      "Salça, baharatlar",
      "Yumurta (üzeri için)",
      "Pekala Ayran"
    ],
    instructions: [
      "Hamuru hazırlayıp mayalayın.",
      "Kıymayı soğan ve sebzelerle kavurun.",
      "Hamuru uzun oval açın.",
      "Harcı yayıp kenarlarını katlayın.",
      "Yumurta sürüp fırınlayın.",
      "Dilimleyip Pekala ayran ile servis edin."
    ],
    tips: "Pide hamurunu iyi mayalamak yumuşak pide sırrıdır. Sıcak pide, soğuk Pekala ayran ile en iyi şekilde tadılır."
  },
  {
    id: 9,
    title: "Pekala Limonata ile Tavuk Şiş",
    category: "Ana Yemek",
    image: "https://customer-assets.emergentagent.com/job_pekalasut-portal/artifacts/reut3i1y_Pekala%20Limonata%20ile%20Tavuk%20%C5%9Ei%C5%9F.png",
    description: "Marine edilmiş tavuk şiş, yanında ferahlatıcı Pekala limonata ile yaz akşamlarının favorisi.",
    prepTime: "20 dakika + marinasyon",
    cookTime: "15 dakika",
    servings: "4 kişilik",
    difficulty: "Kolay",
    pekaraProduct: "Pekala Limonata",
    ingredients: [
      "600g tavuk göğüs",
      "1 su bardağı yoğurt",
      "2 yemek kaşığı zeytinyağı",
      "Limon suyu",
      "Baharatlar",
      "Soğan, biber (şişe dikmek için)",
      "Pilav",
      "Pekala Limonata"
    ],
    instructions: [
      "Tavukları küp doğrayın.",
      "Yoğurt ve baharatlarla marine edin (2 saat).",
      "Şişlere dizin.",
      "Izgarada veya fırında pişirin.",
      "Pilav ve sebzelerle tabağa alın.",
      "Buzlu Pekala limonata ile servis edin."
    ],
    tips: "Tavuğu en az 2 saat marine etmek lezzeti artırır. Pekala limonata, ızgara yemeklerin yanında ferahlık verir."
  },
  {
    id: 10,
    title: "Pekala Yoğurt ile Mercimek Çorbası",
    category: "Çorba",
    image: "https://customer-assets.emergentagent.com/job_pekalasut-portal/artifacts/ekwxavq9_Pekala%20Yo%C4%9Furt%20ile%20Mercimek%20%C3%87orbas%C4%B1.png",
    description: "Sıcacık mercimek çorbası, üzerine Pekala yoğurt ile soğuk kış günlerinin vazgeçilmezi.",
    prepTime: "10 dakika",
    cookTime: "30 dakika",
    servings: "6 kişilik",
    difficulty: "Kolay",
    pekaraProduct: "Pekala Yoğurt",
    ingredients: [
      "1.5 su bardağı kırmızı mercimek",
      "1 soğan",
      "1 havuç",
      "1 patates",
      "1 yemek kaşığı salça",
      "Zeytinyağı",
      "Baharatlar",
      "Pekala Yoğurt (servis için)",
      "Limon"
    ],
    instructions: [
      "Mercimeği yıkayın.",
      "Sebzeleri doğrayıp kavurun.",
      "Mercimek ve suyu ekleyin.",
      "Yumuşayana kadar pişirin.",
      "Blenderdan geçirin.",
      "Kaseye alın, üzerine Pekala yoğurt ve limon sıkın."
    ],
    tips: "Mercimek çorbasına havuç eklemek doğal tatlılık katar. Üzerine eklenen Pekala yoğurt, çorbanın lezzetini tamamlar."
  }
];

export const companyInfo = {
  name: "Arjin Tekstil Petrol San. Tic. Ltd. Şti.",
  branch: "ASMİN SÜT ŞUBESİ",
  address: "Koçören 2. OSB Mh. 222. Cd. No:4 - Eyyubiye/ŞANLIURFA",
  phone: "0543 202 63 63",
  email: "pekala_sut_urunleri@hotmail.com",
  country: "Türkiye",
  mapUrl: "https://www.google.com/maps?q=Ko%C3%A7%C3%B6ren+2.+OSB+Mh.+222.+Cd.+No:4,+Eyyubiye,+%C5%9Eanl%C4%B1urfa&output=embed"
};

export const heroImages = {
  main: "https://customer-assets.emergentagent.com/job_pekala-natural/artifacts/lb3zrusa_Aile%20Kahvalt%C4%B1s%C4%B1%20Ayran.png",
  ayranFamily: "https://customer-assets.emergentagent.com/job_pekala-natural/artifacts/3znyj9kt_Ayran%20Ailesi%20Web%20Banner.png",
  ayranGlass: "https://customer-assets.emergentagent.com/job_pekala-natural/artifacts/d9qa1gn5_Ayran%20Cam%20Y%C3%BCzey%20Parallax.png",
  duoProduct: "https://customer-assets.emergentagent.com/job_pekala-natural/artifacts/aijh7c7p_Duo%20%C3%9Cr%C3%BCn%20Floating%20Parallax.png",
  quality1: "https://images.unsplash.com/photo-1658345542617-63c9fee8a2e3",
  quality2: "https://images.unsplash.com/photo-1696934466894-0c1dc46f919b",
  orchard: "https://images.unsplash.com/photo-1746981422898-28e48d7a905c"
};
